import { fleetKpis } from '../lib/fleet-kpis.js';

// Two compact, neutral KPI chips for one fleet row (ENTRAID-333): onGuard score and Microsoft Secure Score.
// Each chip names its metric, so the two never read as one score. The accent is a small dot, never a colored fill.

const DOT = Object.freeze({ good: 'bg-emerald-500', mid: 'bg-amber-400', low: 'bg-slate-400', none: 'bg-slate-200' });

export default function FleetKpis({ customer }) {
  return (
    <ul className="flex flex-wrap items-center gap-1.5 list-none m-0 p-0" aria-label="Customer scores">
      {fleetKpis(customer).map((k) => (
        <li
          key={k.id}
          title={k.title}
          aria-label={k.title}
          data-kpi={k.id}
          className="inline-flex items-center gap-1.5 rounded-md border border-slate-200 bg-slate-50 px-1.5 py-0.5 text-[11px] text-slate-600"
        >
          <span className={`inline-block h-1.5 w-1.5 rounded-sm ${DOT[k.accent]}`} aria-hidden="true" />
          <span>{k.label}</span>
          <span className={k.value == null ? 'text-ipc-muted' : 'font-semibold text-slate-800'}>{k.text}</span>
        </li>
      ))}
    </ul>
  );
}
